import { createRouter, createWebHistory } from 'vue-router'
import { useAppStore } from '@/stores/app'
import { safeAuthReturnPath } from '@/utils/navigation'
import DetailView from '@/views/DetailView.vue'
import HomeView from '@/views/HomeView.vue'
import LibraryView from '@/views/LibraryView.vue'
import MeView from '@/views/MeView.vue'
import SearchView from '@/views/SearchView.vue'

const loadPlayerView = () => import('@/views/PlayerView.vue')
export function preloadPlayerView() { return loadPlayerView() }

export const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, saved) {
        if (saved) { return saved }
        if (to.hash) { return { el: to.hash } }
        if (to.path === from.path) { return false }
        return { top: 0 }
    },
    routes: [
        { path: '/', name: 'home', component: HomeView },
        { path: '/search', name: 'search', component: SearchView },
        { path: '/detail/:source/:id', name: 'detail', component: DetailView },
        { path: '/play/:source/:id/:episode?', name: 'play', component: loadPlayerView, meta: { immersive: true } },
        { path: '/library', name: 'library', component: LibraryView },
        { path: '/me', name: 'me', component: MeView },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('@/views/AdminView.vue'),
            beforeEnter: async (to) => {
                const app = useAppStore()
                if (!app.initialized) { await app.initialize() }
                if (!app.authenticated) { return { path: '/login', query: { redirect: to.fullPath } } }
                return app.isOwner ? true : { path: '/me' }
            },
        },
        { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/LoginView.vue'),
            meta: { immersive: true, public: true },
        },
        { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/views/NotFoundView.vue') },
    ],
})

router.beforeEach(async (to) => {
    const app = useAppStore()
    if (!app.initialized) { await app.initialize() }
    if (to.meta.public) {
        return app.authenticated ? safeAuthReturnPath(to.query.redirect) : true
    }
    if (!app.authenticated) {
        return { path: '/login', query: { redirect: to.fullPath }, replace: true }
    }
    return true
})
